//#region src/env.ts
const getEnvPlayerVersion = () => {
	try {
		return "10.1.0";
	} catch {}
	return "UNKNOWN";
};
const player_version = getEnvPlayerVersion();
const getPlayerVersion = () => player_version;
//#endregion
export { getPlayerVersion };
